/**
 * Items Service Factory
 *
 * Creates and initializes service instances with their dependencies.
 * Provides a single point for dependency injection configuration.
 */

import { CategoryService } from "../../application/services/CategoryService";
import { CategoryRepository } from "../repositories/Category.repository";

let categoryService: CategoryService | null = null;

/**
 * Get or create CategoryService singleton
 */
export function getCategoryService(): CategoryService {
  if (!categoryService) {
    const categoryRepository = new CategoryRepository();
    categoryService = new CategoryService(categoryRepository);
  }
  return categoryService;
}

/**
 * Reset services (useful for testing)
 */
export function resetServices(): void {
  categoryService = null;
}
